export const SECTION_TITLE = 'Prodotti presenti';
export const SECTION_SINGLE_TITLE = 'Prodotto presente';
